<template>
  <div id="Application">

    <!-- CASPA Deadline Type DIALOG -->
    <v-dialog
      v-model="showCaspaDeadlineTypeDialog"
      scrollable
      max-width="400"
      persistent
      style="zIndex:2000"
      >

      <v-card style="borderRadius:10px" >
        <v-card-title class="title grey lighten-2 text-xs-center mb-2">
          CASPA Deadline Type - {{school.application_deadline_type | capitalizeString}}

        </v-card-title>
        <!-- Verified -->
        <v-card-text class="text-xs-justify"  v-if="school.application_deadline_type === 'verified'">
          Applications must be verified by 11:59 PM ET on the deadline date. Applications can only be verified once all payments, transcripts, and letters of evaluation have been received. To ensure your application is verified on time, try to complete your application at least four weeks before the deadline.
        </v-card-text>
        <!-- Completed -->
        <v-card-text class="text-xs-justify"  v-if="school.application_deadline_type.toLowerCase() === 'completed'">
          Application, payments, transcripts, and at least two letters of evaluation must be received by 11:59 PM ET on the deadline date. To ensure items arrive on time, try to send all documents several weeks before the deadline.
        </v-card-text>
        <!-- Submitted -->
        <v-card-text class="text-xs-justify"  v-if="school.application_deadline_type === 'submitted'">
          Applications must be submitted by 11:59 PM ET on the deadline date. Program materials do not have to be received by the deadline date.
        </v-card-text>
        <v-card-text class="text-xs-justify mt-0 pt-0" >
          <span>You can read more about CASPA deadline types at <a href="https://help.liaisonedu.com/CASPA_Applicant_Help_Center/Starting_Your_CASPA_Application/Getting_Started_with_Your_CASPA_Application/3_CASPA_Participating_Programs_and_Eligibility" class="blue--text  " target="_blank">CASPA Deadlines </a></span>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="showCaspaDeadlineTypeDialog = false" block color="red" class="elevation-0" dark >Close</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <!-- Application info -->
    <v-card flat id="buttonShadow" class="mt-6 pb-2">
         <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0">
        <span class="title font-weight-regular  align-center mt-1">Application Information </span>

      </v-layout>
      <v-container fluid px-5>
        <v-layout column>



          <!-- Deadline Date -->
          <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Deadline Date</span>

             <span v-if="(school.application_deadline === '' || school.application_deadline === undefined ) &&  (school.direct_school_application_deadline === '' || school.direct_school_application_deadline === undefined)"  class="grey--text ">Not Listed</span>

              <p v-if="(school.application_deadline !== '' && school.application_deadline !== undefined ) && school.caspa_participant" class="subheading  mb-0 green--text ">{{school.application_deadline | removeTimeFromDate | moment(" MM/DD/YYYY")}}</p>

              <p v-if="school.direct_school_application_deadline && school.direct_school_application" class="subheading  mb-0 green--text ">{{school.direct_school_application_deadline | removeTimeFromDate | moment(" MM/DD/YYYY")}}</p>
          </v-layout>

          <v-divider class="mt-1 mb-1"></v-divider>

          <!-- Submitted Through -->
          <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light">Submitted To</span>
            <p v-if="school.caspa_participant" class="subheading  blue--text text--darken-3 mb-0">CASPA</p>
            <p v-else class="subheading mb-0 blue--text text--darken-3">School Directly</p>
          </v-layout>

          <v-divider class="mt-1 mb-1"></v-divider>

          <!-- CASPA Deadline Type -->
          <v-layout v-if="school.caspa_participant" mt-1 row   align-baseline justify-space-between mx-0>
            <span class="font-weight-light" >CASPA Deadline Type <v-icon v-if="school.application_deadline_type" small class="mb-1" @click="showCaspaDeadlineTypeDialog = true">mdi-information</v-icon></span>
            <span v-if="school.application_deadline_type === '' || school.application_deadline_type === undefined"  class="grey--text ">Not Listed</span>
            <p v-else class=" subheading blue--text text--darken-3 mb-0">{{school.application_deadline_type | capitalizeString}}</p>
          </v-layout>

          <v-divider v-if="school.caspa_participant"  class="mt-1 mb-1"></v-divider>

           <!-- Supplemental Application-->
          <v-card v-if="school.supplemental_application" flat>

            <v-layout  mt-1 row   align-baseline justify-space-between mx-0>
              <span class="font-weight-light mb-1">Supplemental Application </span>
              <p class=" subheading red--text  mb-0">Required</p>

            </v-layout>

            <v-divider  class="mt-1 mb-1"></v-divider>

            <!-- Supplemental Application Deadline-->
            <v-layout  mt-2 row   align-baseline justify-space-between mx-0>
              <span class="font-weight-light mb-1">Supplemental Deadline </span>
              <p v-if="school.supplemental_application_deadline" class=" subheading mb-0  green--text">{{school.supplemental_application_deadline | removeTimeFromDate | moment("MM/DD/YYYY")}}</p>
              <span v-else class="grey--text">Not Listed</span>
            </v-layout>

            <v-divider  class="mt-1 mb-1"></v-divider>

             <!-- Supplemental Fee-->
            <v-layout v-if="school.supplemental_application_fee !== ''" mt-1 row   align-baseline justify-space-between mx-0>
              <span class="mb-1 font-weight-light"> Fee</span>
              <p class=" subheading mb-0 blue--text text--darken-3  "> ${{school.supplemental_application_fee}}</p>
            </v-layout>

            <v-divider  v-if="school.supplemental_application_fee !== ''" class="mt-1 mb-1"></v-divider>

            <!-- Supplemental Application Link  -->

            <v-layout v-if="school.supplemental_application_link !== '' || school.supplemental_application_provided_invitation " mt-1 row   align-baseline justify-space-between  mx-0>
              <span class="mb-1 font-weight-light"> Application Link</span>
              <a v-if="school.supplemental_application_link !== '' && school.supplemental_application_provided_invitation === false" :href="school.supplemental_application_link" class="ml-2 blue--text subheading ">Supplemental Application </a>
               <span v-if="school.supplemental_application_provided_invitation" class="mb-1 blue--text text--darken-3 ">  Provided With Invitation Only</span>
            </v-layout>


            <v-divider v-if="school.supplemental_application_link !== '' "  class="mt-1 mb-1"></v-divider>
          </v-card>





        </v-layout>
      </v-container>
       <!-- Details Notes -->
        <v-card  v-if="school.applicationNotes" outlined class="mx-5 mt-4 mb-4 ">
          <v-layout align-center justify-center class=" pb-1" >
            <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
            <span class="font-weight-light align-center">Notes </span>
          </v-layout>
          <v-divider></v-divider>
          <v-card-text class="text-center">
            <span>{{school.applicationNotes}}</span>
          </v-card-text>
        </v-card>
    </v-card>
  </div>
</template>


<script>

  export default {
    props: ['school'],
    data() {
      return  {
        showCaspaDeadlineTypeDialog: false,
      }
    },
    filters: {
        capitalizeString(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
  }
</script>

<style scoped>

 .card {
    border-radius: 10px;
  }

.progress-circular {
  text-align: center;
}

#nonScience {
  font-size: 10px;
}

.value {
  margin-left:150px
}

.percentageValue {
  color:rgb(85, 85, 85);
  font-size: 14px;
}

  #buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

#secondaryButtonShadow {
  box-shadow: 0 10px 20px -11px rgba(0,0,0,.19);
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/Application.vue